import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import {
    Table,
    Grid,
    Paper,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    CardHeader,
    Typography,
    Fab,
    CardContent,
    Button
} from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import CreateRate from './CreateRate'
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmationDialog from 'common/components/ConfirmationDialog';
import { deleteDepreciationRate } from '../../api/apiDepreciationRate';
import { getRateDetailsByAssetId } from '../../api/apiAsset';
import WrappedTextField from 'common/components/custom/WrappedTextField';
import NumberFormat from "react-number-format";
import moment from 'moment'

class DepreciationRates extends Component {

    emptyDepreciationAttr = {
        endDate: '',
        totalMonths: '',
        sum: ''
    }

    emptyRateDetails = {
        assetName: '',
        assetInventoryNumber: '',
        purchaseAmount: '',
        regularRate: '',
        acceleratedRate: '',
        depreciationRates: [],
        depreciationAttr: this.emptyDepreciationAttr
    }

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isOpen: false,
            dialogOpen: false,
            depreciationRatesToDelete: null,
            depreciationRatesToEdit: null,
            rateDetails: this.emptyRateDetails,
            selectedFrom: props.location.state && props.location.state.selectedFrom ? props.location.state.selectedFrom : null,
            selectedTo: props.location.state && props.location.state.selectedTo ? props.location.state.selectedTo : null,
            selectedInventory: props.location.state && props.location.state.selectedInventory ? props.location.state.selectedInventory : null,
            selectedDepreciationGroup: props.location.state && props.location.state.selectedDepreciationGroup ? props.location.state.selectedDepreciationGroup : null,
            selectedClient: props.location.state && props.location.state.selectedClient ? props.location.state.selectedClient : null,
            selectedRadioButton: props.location.state && props.location.state.selectedRadioButton ? props.location.state.selectedRadioButton : "currentMonth",
            inactiveAssets: props.location.state && props.location.state.inactiveAssets ? props.location.state.inactiveAssets : false
        };
    }

    closeDialog = () => {
        this.setState({ isOpen: false, depreciationRatesToEdit: null });
    }

    async componentDidMount() {
        this.getRateDetailsByAssetId()
    }

    getRateDetailsByAssetId = () => {
        let requestBody = {
            depreciationFrom: moment(this.state.selectedFrom).format("DD-MM-YYYY"),
            depreciationTo: moment(this.state.selectedTo).format("DD-MM-YYYY")
        }
        getRateDetailsByAssetId(this.props.match.params.id, requestBody).then(response => {
            this.setState({
                rateDetails: response.data.data,
                isLoading: false
            });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_asset_by_id"), { variant: 'error' });
        });
    }

    deleteDepreciationRate = () => {
        let { depreciationRatesToDelete } = this.state
        deleteDepreciationRate(depreciationRatesToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_depreciation_rate", { rate: this.state.depreciationRatesToDelete.rate }), { variant: 'success' });
            this.setState({ dialogOpen: false, depreciationRatesToDelete: null }, () => this.getRateDetailsByAssetId());
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_depreciation_rate"), { variant: 'error' });
        });
    }

    render() {
        let { isOpen, rateDetails, dialogOpen, depreciationRatesToDelete, depreciationRatesToEdit } = this.state
        let { t } = this.props

        let depreciationRatesList;
        if (rateDetails.depreciationRates && rateDetails.depreciationRates.length > 0) {
            depreciationRatesList = rateDetails.depreciationRates.map((depreciationRate, index) => {
                return <TableRow key={index}>
                    <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} value={depreciationRate.rate} /></TableCell>
                    <TableCell>{depreciationRate.startDate}</TableCell>
                    <TableCell>{depreciationRate.rateMonths}</TableCell>
                    <TableCell><NumberFormat displayType="text" decimalScale={6} fixedDecimalScale={true} thousandSeparator={true} value={depreciationRate.rateMonthlyAmount} /></TableCell>
                    <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={depreciationRate.rateTotalAmount} /></TableCell>
                    <TableCell>
                        <Fab title={this.props.t("edit")} onClick={() => this.setState({ depreciationRatesToEdit: depreciationRate, isOpen: true })} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                            <EditIcon />
                        </Fab>
                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ depreciationRatesToDelete: depreciationRate, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                            <DeleteIcon />
                        </Fab>
                    </TableCell>
                </TableRow>
            });
        }

        let depreciationAttrList;
        if (rateDetails.depreciationAttr) {
            depreciationAttrList = <TableRow>
                <TableCell className="table-body-custom" />
                <TableCell>{rateDetails.depreciationAttr.endDate}</TableCell>
                <TableCell>{rateDetails.depreciationAttr.totalMonths}</TableCell>
                <TableCell className="table-body-custom" />
                <TableCell><NumberFormat displayType="text" decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} value={rateDetails.depreciationAttr.totalBalance} /></TableCell>
                <TableCell className="table-body-custom" />
            </TableRow>
        }

        return (
            <Grid container direction="row" spacing={2}>
                <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CardHeader
                        style={{ height: '62px' }}
                        title={<Typography variant={"h6"}>{t("depreciation_rate")}</Typography>}
                        avatar={
                            <Fab
                                size="small"
                                color="secondary"
                                component={Link}
                                to={{
                                    pathname: this.state.inactiveAssets ? `/inactive-assets` : `/assets`,
                                    state: {
                                        selectedInventory: this.state.selectedInventory,
                                        selectedClient: this.state.selectedClient,
                                        selectedFrom: this.state.selectedFrom,
                                        selectedTo: this.state.selectedTo,
                                        selectedDepreciationGroup: this.state.selectedDepreciationGroup,
                                        selectedRadioButton: this.state.selectedRadioButton
                                    }
                                }}
                            >
                                <ArrowBack />
                            </Fab>
                        }
                        action={
                            <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ isOpen: true })} style={{ top: '4px' }}>
                                {this.props.t("add_new_rate")}
                            </Button>
                        } />
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={4} sm={5} md={5} lg={4} xl={4}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"asset_name"}
                                                disabled={true}
                                                value={rateDetails.assetName}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={3} sm={3} md={4} lg={3} xl={3}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"asset_inventory_number"}
                                                disabled={true}
                                                value={rateDetails.assetInventoryNumber}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={2} sm={2} md={3} lg={2} xl={2}>
                                        <Grid item container>
                                            <NumberFormat
                                                customInput={WrappedTextField}
                                                label={"purchase_amount"}
                                                disabled={true}
                                                thousandSeparator={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                value={rateDetails.purchaseAmount}
                                                suffix=" HRK"
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={2} sm={2} md={3} lg={2} xl={2}>
                                        <Grid item container>
                                            <NumberFormat
                                                customInput={WrappedTextField}
                                                label={"residual_value"}
                                                disabled={true}
                                                thousandSeparator={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                value={rateDetails.residualValue}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"regular_rate"}
                                                disabled={true}
                                                value={rateDetails.regularRate || ''}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <Grid item container>
                                            <WrappedTextField
                                                label={"accelerated_rate"}
                                                disabled={true}
                                                value={rateDetails.acceleratedRate || ''}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("rate")}</TableCell>
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("start_date")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("number_of_months")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("monthly_amount")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("total_amount")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%" />
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {depreciationRatesList}
                                                </TableBody>
                                            </Table>
                                            <br />
                                            <Table aria-label="simple table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="table-body-custom" style={{ backgroundColor: 'white' }} component="th" scope="row" width="20%" />
                                                        <TableCell component="th" scope="row" width="20%">{this.props.t("end_date")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("total_months")}</TableCell>
                                                        <TableCell className="table-body-custom" style={{ backgroundColor: 'white' }} component="th" scope="row" width="15%" />
                                                        <TableCell component="th" scope="row" width="15%">{this.props.t("sum")}</TableCell>
                                                        <TableCell className="table-body-custom" style={{ backgroundColor: 'white' }} component="th" scope="row" width="15%" />
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {depreciationAttrList}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Grid>
                <CreateRate
                    isOpen={isOpen}
                    closeDialog={this.closeDialog}
                    assetId={this.props.match.params.id}
                    depreciationRate={rateDetails.depreciationRates[0]}
                    depreciationRatesToEdit={depreciationRatesToEdit ? depreciationRatesToEdit : null}
                    getRateDetailsByAssetId={() => this.getRateDetailsByAssetId(this.props.match.params.id)}
                />
                {
                    depreciationRatesToDelete && <ConfirmationDialog
                        isOpen={dialogOpen}
                        title={this.props.t("delete_depreciation_rate")}
                        message={this.props.t("delete_depreciation_rate_dialog_message", { rate: depreciationRatesToDelete.rate })}
                        onClose={() => this.setState({ dialogOpen: false })}
                        onConfirm={() => this.setState({ dialogOpen: false }, () => this.deleteDepreciationRate())}
                        closeButtonTitle={this.props.t("close")}
                        confirmButtonTitle={this.props.t("delete")}
                    />
                }
            </Grid>
        );
    }
}

export default withSnackbar(withRouter(withTranslation()(DepreciationRates)));
